<template>
	<div>
		<vx-card :title="$t('Preferences.FindExactly')" class="mb-base" id="search-type">
			<p>
				{{ $t("Preferences.AllowsFindExactly") }}
			</p>
			<ul class="demo-alignment">
				<li>
					<vs-checkbox v-model="isExactlyOptimization">{{ $t("Optimization.Optimizations") }}</vs-checkbox>
				</li>
				<li>
					<vs-checkbox v-model="isExactlySkill">{{ $t("Skills.Skills") }}</vs-checkbox>
				</li>
				<li>
					<vs-checkbox v-model="isExactlyCapacity">{{ $t("Capacity.Capabilities") }}</vs-checkbox>
				</li>
				<li>
					<vs-checkbox v-model="isExactlyTimeWindow">{{ $t("TimeWindow.TimeWindows") }}</vs-checkbox>
				</li>
				<li>
					<vs-checkbox v-model="isExactlyFrequency">{{ $t("Frequency.Frequencies") }}</vs-checkbox>
				</li>
				<li>
					<vs-checkbox v-model="isExactlyVehicle">{{ $t("Vehicles.Vehicles") }}</vs-checkbox>
				</li>
				<li>
					<vs-checkbox v-model="isExactlyVisitPoint">{{ $t("Routing.Title.VisitPoints") }}</vs-checkbox>
				</li>
			</ul>
			<ul class="demo-alignment">
				<li>
					<vs-checkbox v-model="isExactlyBreak">{{ $t("Breaks") }}</vs-checkbox>
				</li>
				<li>
					<vs-checkbox v-model="isExactlyOptimizationGroup">{{ $t("Group.OptimizationGroups") }}</vs-checkbox>
				</li>
				<li>
					<vs-checkbox v-model="isExactlyCompany">{{ $t("Company") }}</vs-checkbox>
				</li>
				<li>
					<vs-checkbox v-model="isExactlyResource">{{ $t("User") }}</vs-checkbox>
				</li>
			</ul>
			<vs-button type="filled" class="mt-5 block" @click.prevent="updateMatchFilter()"
				>{{ $t("Save") }}
			</vs-button>
		</vx-card>
		<vx-card :title="$t('Languages.Language') + ' ' + $t('Default')" class="mb-base" id="language">
			<label class="vs-input--label">{{ $t("Languages.Languages") }}</label>
			<vx-input-group class="mb-base">
				<template slot="prepend">
					<div class="prepend-text border-solid d-theme-border-grey-light">
						<span class="cursor-pointer flex items-center i18n-locale">
							<img class="h-4 w-5" :src="i18n_locale_img" :alt="$i18n.locale" />
						</span>
					</div>
				</template>

				<v-select
					v-model="language"
					:clearable="false"
					:options="languageOptions"
					:dir="$vs.rtl ? 'rtl' : 'ltr'"
				>
					<template v-slot:no-options="{search, searching}">
						<template v-if="searching">
							{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
						</template>
						<template v-else>
							{{ $t("NoResultsFound") }}
						</template>
					</template>
				</v-select>
			</vx-input-group>

			<vs-button type="filled" @click.prevent="updatePreferences('language')" class="mt-5 block">{{
				$t("Save")
			}}</vs-button>
		</vx-card>

		<vx-card :title="$t('Notification.AppNotifications')" class="mb-base" id="notifications">
			<div class="vx-row">
				<div class="vx-col w-1/2 items-center sm:flex hidden">
					<p class="mb-4">{{ $t("Preferences.NotificationNumberDays") }}</p>
				</div>
				<div class="vx-col w-1/2">
					<v-select
						v-model="numDays"
						:clearable="false"
						:options="[1, 2, 3, 4, 5, 6, 7]"
						:dir="$vs.rtl ? 'rtl' : 'ltr'"
					>
						<template v-slot:no-options="{search, searching}">
							<template v-if="searching">
								{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
							</template>
							<template v-else>
								{{ $t("NoResultsFound") }}
							</template>
						</template>
					</v-select>
				</div>
			</div>

			<div class="vx-row mt-4">
				<div class="vx-col w-1/2 items-center sm:flex hidden">
					<p class="mb-4">{{ $t("Preferences.NotificationNumber") }}</p>
				</div>
				<div class="vx-col w-1/2">
					<v-select
						v-model="numNotification"
						:clearable="false"
						:options="[50, 100, 300, 500, 1000]"
						:dir="$vs.rtl ? 'rtl' : 'ltr'"
					>
						<template v-slot:no-options="{search, searching}">
							<template v-if="searching">
								{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
							</template>
							<template v-else>
								{{ $t("NoResultsFound") }}
							</template>
						</template>
					</v-select>
				</div>
			</div>

			<div class="vx-row mt-4">
				<div class="vx-col w-1/2 items-center sm:flex hidden">
					<p class="mb-4">{{ $t("Preferences.DeleteOldNotification") }}</p>
				</div>
				<div class="vx-col w-1/2">
					<vs-switch class="mt-2" color="success" v-model="removeOldNotification" />
				</div>
			</div>

			<vs-button type="filled" @click.prevent="updatePreferences('notifications')" class="mt-5">{{
				$t("Save")
			}}</vs-button>
		</vx-card>
	</div>
</template>

<script>
import vSelect from "vue-select";

export default {
	components: {
		vSelect,
	},
	data() {
		return {
			filterType: false,
			language: {value: "es", label: this.$t("Languages.Spanish")},
			numDays: 1,
			numNotification: 100,
			removeOldNotification: false,
			isExactlyResource: false,
			isExactlyBreak: false,
			isExactlyCapacity: false,
			isExactlyCompany: false,
			isExactlyVehicle: false,
			isExactlyVisitPoint: false,
			isExactlyOptimization: false,
			isExactlySkill: false,
			isExactlyOptimizationGroup: false,
			isExactlyTimeWindow: false,
			isExactlyFrequency: false,
		};
	},
	computed: {
		languageOptions() {
			return [
				{value: "es", label: this.$t("Languages.Spanish")},
				{value: "en", label: this.$t("Languages.English")},
				{value: "pt", label: this.$t("Languages.Portuguese")},
			];
		},
		i18n_locale_img() {
			const locale = this.language.value;
			if (locale === "en") return require("@/assets/images/flags/en.png");
			else if (locale === "pt") return require("@/assets/images/flags/br.svg");
			else if (locale === "fr") return require("@/assets/images/flags/fr.png");
			else if (locale === "de") return require("@/assets/images/flags/de.png");
			else if (locale === "es") return require("@/assets/images/flags/es.png");
			else return require("@/assets/images/flags/en.png");
		},
		getCurrentLocaleData() {
			const locale = this.$i18n.locale;
			if (locale === "en") return {flag: "us", lang: this.$t("Languages.English")};
			else if (locale === "pt") return {flag: "br", lang: this.$t("Languages.Portuguese")};
			else if (locale === "fr") return {flag: "fr", lang: this.$t("Languages.French")};
			else if (locale === "de") return {flag: "de", lang: this.$t("Languages.German")};
			else if (locale === "es") return {flag: "es", lang: this.$t("Languages.Spanish")};
		},
	},
	methods: {
		updateLocale(locale) {
			this.language = this.languageOptions.find((language) => language.value === locale);
		},
		async updatePreferences(preferenceName) {
			const payload = {};

			if (preferenceName === "filter_exact_values") {
				payload[preferenceName] = this.filterType;
			}

			if (preferenceName === "notifications") {
				payload["notifications_days"] = this.numDays;
				payload["notifications_number"] = this.numNotification;
				payload["remove_old_notifications"] = this.removeOldNotification;
			}

			if (preferenceName === "language") {
				payload[preferenceName] = this.language.value;
			}

			try {
				await this.$store.dispatch("modulePreferences/updatePreferences", payload);
				this.$vs.notify({
					color: "success",
					title: this.$t("Preferences.Preferences"),
					text: this.$t("Setting.Saved"),
				});

				if (preferenceName === "notifications") {
					this.$store.commit("setReloadNotificationTrigger");
				}

				if (preferenceName === "language") {
					this.$i18n.locale = this.language.value;
					this.$store.commit("UPDATE_LOCALE_APP", this.language.value);
				}
			} catch (error) {
				this.$vs.notify({
					color: "danger",
					title: this.$t("ErrorTitle"),
					text: this.$t("ErrorMessage"),
				});
			}
		},
		update(payload) {
			this.$store.dispatch("modulePreferences/updatePreferences", payload);
		},
		moveScroll(id) {
			const elem = document.getElementById(id);
			elem.scrollIntoView();
		},
		async updateMatchFilter() {
			const payload = {};
			payload["filter_exact_resource"] = this.isExactlyResource;
			payload["filter_exact_break"] = this.isExactlyBreak;
			payload["filter_exact_capacity"] = this.isExactlyCapacity;
			payload["filter_exact_company"] = this.isExactlyCompany;
			payload["filter_exact_vehicle"] = this.isExactlyVehicle;
			payload["filter_exact_visit_point"] = this.isExactlyVisitPoint;
			payload["filter_exact_optimization"] = this.isExactlyOptimization;
			payload["filter_exact_skill"] = this.isExactlySkill;
			payload["filter_exact_timewindow"] = this.isExactlyTimeWindow;
			payload["filter_exact_frequency"] = this.isExactlyFrequency;
			payload["filter_exact_optimization_group"] = this.isExactlyOptimizationGroup;
			try {
				await this.$store.dispatch("moduleMatchFilter/updateMatchFilter", payload);
				this.$vs.notify({
					color: "success",
					title: this.$t("Preferences.Preferences"),
					text: this.$t("Setting.Saved"),
				});
			} catch (error) {
				this.$vs.notify({
					color: "danger",
					title: this.$t("ErrorTitle"),
					text: this.$t("ErrorMessage"),
				});
			}
		},
	},
	async created() {
		this.filterType = this.$store.state.modulePreferences.filter_exact_values;
		this.numDays = this.$store.state.modulePreferences.notifications_days;
		this.numNotification = this.$store.state.modulePreferences.notifications_number;
		this.removeOldNotification = this.$store.state.modulePreferences.remove_old_notifications;
		const matchFilter = await this.$store.dispatch("moduleMatchFilter/getMatchFilter");
		if (Object.entries(matchFilter) > 0) {
			this.isExactlyResource = matchFilter.filter_exact_resource;
			this.isExactlyBreak = matchFilter.filter_exact_break;
			this.isExactlyCompany = matchFilter.filter_exact_company;
			this.isExactlyVehicle = matchFilter.filter_exact_vehicle;
			this.isExactlyVisitPoint = matchFilter.filter_exact_visit_point;
			this.isExactlyOptimization = matchFilter.filter_exact_optimization;
			this.isExactlyCapacity = matchFilter.filter_exact_capacity;
			this.isExactlySkill = matchFilter.filter_exact_skill;
			this.isExactlyTimeWindow = matchFilter.filter_exact_timewindow;
			this.isExactlyFrequency = matchFilter.filter_exact_frequency;
			this.isExactlyOptimizationGroup = matchFilter.filter_exact_optimization_group;
		} else {
			this.isExactlyResource = this.$store.state.moduleMatchFilter.filter_exact_resource;
			this.isExactlyBreak = this.$store.state.moduleMatchFilter.filter_exact_break;
			this.isExactlyCompany = this.$store.state.moduleMatchFilter.filter_exact_company;
			this.isExactlyVehicle = this.$store.state.moduleMatchFilter.filter_exact_vehicle;
			this.isExactlyVisitPoint = this.$store.state.moduleMatchFilter.filter_exact_visit_point;
			this.isExactlyOptimization = this.$store.state.moduleMatchFilter.filter_exact_optimization;
			this.isExactlyCapacity = this.$store.state.moduleMatchFilter.filter_exact_capacity;
			this.isExactlySkill = this.$store.state.moduleMatchFilter.filter_exact_skill;
			this.isExactlyTimeWindow = this.$store.state.moduleMatchFilter.filter_exact_timewindow;
			this.isExactlyFrequency = this.$store.state.moduleMatchFilter.filter_exact_frequency;
			this.isExactlyOptimizationGroup = this.$store.state.moduleMatchFilter.filter_exact_optimization_group;
		}
		this.updateLocale(this.$store.state.modulePreferences.language);
	},
	mounted() {
		const preferenceId = this.$route.params.id;
		if (preferenceId) this.moveScroll(preferenceId);
	},
};
</script>
